
import config from './map.conf'

class loadBMap {
    ready (callback) {
        if (window.BMap) {
          callback()
        } else {
          setTimeout(function () {
            $tool.loadScript(`${config.B_DOMAIN}/api?v=2.0&ak=${config.B_KEY}&callback=mapCallback`, function () {
              window.mapCallback = () => {
                callback()
              }
            })
          }, 500)
        }
    }
}

export default loadBMap